import { Directive } from '@angular/core';
import { CriteriaObj } from '@src/suite/common/data-models/criteria/criteria-obj';

import { AbstractAdornerDirective } from './abstract-adorner';

@Directive({
    selector: '[st-topic-icon]',
})
export class TopicIconDirective extends AbstractAdornerDirective {
    protected get locationID(): string {
        return this.globalTablesService.adornersIDS.TopicIcon;
    }
    protected applyVC(vcToApply: { visibilityCriteria: CriteriaObj; adorner: Adorner }) {
        // this.renderer.addClass(this.el.nativeElement, "topic-circle");
        this.renderer.addClass(this.el.nativeElement, 'topic-round-icon');
        this.renderer.addClass(this.el.nativeElement, 'left');

        if (vcToApply && vcToApply.adorner) {
            if (vcToApply.adorner.Icon) {
                this.renderer.addClass(this.el.nativeElement, vcToApply.adorner.Icon);
                if (vcToApply.adorner.Color) {
                    this.renderer.setStyle(this.el.nativeElement, 'color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, '-webkit-text-fill-color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, 'font-size', '1.2em');
                }
            } else if (vcToApply.adorner.IconUrl) {
                this.renderer.setStyle(this.el.nativeElement, 'background-image', `url(${vcToApply.adorner.IconUrl})`);
                this.renderer.setStyle(this.el.nativeElement, 'background-size', 'contain');
                if (vcToApply.adorner.Color) {
                    this.renderer.setStyle(this.el.nativeElement, 'color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, '-webkit-text-fill-color', vcToApply.adorner.Color);
                    this.renderer.setStyle(this.el.nativeElement, 'font-size', '1.2em');
                }
            } else if (vcToApply.adorner.Color) {
                this.renderer.setStyle(this.el.nativeElement, 'background-color', vcToApply.adorner.Color);
            } else {
                // default
                this.renderer.setStyle(this.el.nativeElement, 'background-color', '#DBDBDB');
            }
        } else {
            this.renderer.setStyle(this.el.nativeElement, 'background-color', '#DBDBDB');
        }
    }
}
